import { PLAY_MODE, INIT_STYLE, colorAnimTypeList } from './constants';
import { presetClassTypes } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import {
    getAnimTypeByPlayMode,
    getAnimDirection,
    getSlideWidthAndHeight,
    getTnRotate,
} from './utils';

import { getCenterResolveToStyle } from '@src/js/js-keyframe-animation/style-converter/effects/revolve';
import { getEntrBoomerangToStyle, getExitBoomerangToStyle } from '@src/js/js-keyframe-animation/style-converter/effects/boomerang';
import { getEmphOpacityToStyle } from '@src/js/js-keyframe-animation/style-converter/effects/emph';
import { getPointsAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import { getAnimToStyleConverter } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-keyframe-converter/anim-to-style-converter';
import { IAnimModel, IData, IToStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { AnimType, PresetSubtype, IEGTimeNodeChoice } from '@tencent/slide-sdk-model';
import { getEntrFloatToStyle, getExitFloatToStyle } from './effects/float';
import { getSpiralToStype } from './effects/spiral';
import { getBounceToStyle } from './effects/bounce';

type keyFrameArr = IData[];

export interface AnimationStyle {
    translateX?: number | keyFrameArr;
    translateY?: number | keyFrameArr;
    opacity?: number | keyFrameArr;
    scale?: number | keyFrameArr;
    scaleX?: number | keyFrameArr;
    scaleY?: number | keyFrameArr;
    rotate?: number | keyFrameArr;
    rotateY?: number | keyFrameArr;
    easing?: string;
    fillColor?: string | keyFrameArr;
    fontColor?: string | keyFrameArr;
    lineColor?: string | keyFrameArr;
}

let maxWidth = 2000;
let maxHeight = 2000;
let objWidth = 0;
let objHeight = 0;
let objLeft = 0;
let objTop = 0;
let maxY: number;
let minY: number;
let maxX: number;
let minX: number;

function getToStyle() {
    const animDic = {
        [AnimType.FlyOut + PresetSubtype.Top]: {
            translateY: -(objHeight + minY),
            translateX: 0,
        },
        [AnimType.FlyOut + PresetSubtype.Right]: {
            translateX: maxWidth - minX,
            translateY: 0,
        },
        [AnimType.FlyOut + PresetSubtype.TopRight]: {
            translateX: maxWidth - minX,
            translateY: -(objHeight + minY),
        },
        [AnimType.FlyOut + PresetSubtype.Bottom]: {
            translateY: maxHeight - minY,
            translateX: 0,
        },
        [AnimType.FlyOut + PresetSubtype.BottomRight]: {
            translateX: maxWidth - minX,
            translateY: maxHeight - minY,
        },
        [AnimType.FlyOut + PresetSubtype.Left]: {
            translateX: -(objWidth + minX),
            translateY: 0,
        },
        [AnimType.FlyOut + PresetSubtype.TopLeft]: {
            translateX: -(objWidth + minX),
            translateY: -(objHeight + minY),
        },
        [AnimType.FlyOut + PresetSubtype.BottomLeft]: {
            translateX: -(objWidth + minX),
            translateY: maxHeight - minY,
        },
        [AnimType.EnterScale + PresetSubtype.EleCenter]: {
            opacity: 1,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
        },
        [AnimType.EnterScale + PresetSubtype.SlideCenter]: {
            translateX: 0,
            translateY: 0,
            opacity: 1,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
        },
        [AnimType.ExitScale + PresetSubtype.ToEleCenter]: {
            opacity: 0,
            scale: 0,
            scaleX: 0,
            scaleY: 0,
        },
        [AnimType.ExitScale + PresetSubtype.ToSlideCenter]: {
            translateX: (maxWidth / 2) - objLeft - (objWidth / 2),
            translateY: (maxHeight / 2) - objTop - (objHeight / 2),
            opacity: 1,
            scale: 0,
            scaleX: 0,
            scaleY: 0,
        },
        [AnimType.EntrBasicZoom + PresetSubtype.EleCenter]: {
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrBasicZoom + PresetSubtype.SlideCenter]: {
            translateX: 0,
            translateY: 0,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrBasicZoom + PresetSubtype.InSlightly]: {
            translateX: 0,
            translateY: 0,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrBasicZoom + PresetSubtype.ToEleCenter]: {
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrBasicZoom + PresetSubtype.OutBottom]: {
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            translateX: 0,
            translateY: 0,
            opacity: 1,
        },
        [AnimType.EntrBasicZoom + PresetSubtype.OutSlightly]: {
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrStretch + PresetSubtype.Across]: {
            scaleX: 1,
            opacity: 1,
        },
        [AnimType.EntrStretch + PresetSubtype.Top]: {
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrStretch + PresetSubtype.Bottom]: {
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrStretch + PresetSubtype.Left]: {
            scaleX: 1,
            opacity: 1,
        },
        [AnimType.EntrStretch + PresetSubtype.Right]: {
            scaleX: 1,
            opacity: 1,
        },
        [AnimType.ExitCollapse + PresetSubtype.Across]: {
            scaleX: 0,
            opacity: 0,
        },
        [AnimType.ExitCollapse + PresetSubtype.Top]: {
            scaleY: 0,
            opacity: 0,
        },
        [AnimType.ExitCollapse + PresetSubtype.Bottom]: {
            scaleY: 0,
            opacity: 0,
        },
        [AnimType.ExitCollapse + PresetSubtype.Left]: {
            scaleX: 0,
            opacity: 0,
        },
        [AnimType.ExitCollapse + PresetSubtype.Right]: {
            scaleX: 0,
            opacity: 0,
        },
        [AnimType.ExitBasicZoom + PresetSubtype.ToEleCenter]: {
            scale: 0,
            scaleX: 0,
            scaleY: 0,
            opacity: 0,
        },
        [AnimType.ExitBasicZoom + PresetSubtype.ToSlideCenter]: {
            translateX: (maxWidth / 2) - objLeft - (objWidth / 2),
            translateY: (maxHeight / 2) - objTop - (objHeight / 2),
            scale: 0,
            scaleX: 0,
            scaleY: 0,
            opacity: 0,
        },
        [AnimType.ExitBasicZoom + PresetSubtype.OutSlightly]: {
            scale: 2 / 3,
            scaleX: 2 / 3,
            scaleY: 2 / 3,
            opacity: 0,
        },
        [AnimType.ExitBasicZoom + PresetSubtype.EleCenter]: {
            scale: 4,
            scaleX: 4,
            scaleY: 4,
            opacity: 0,
        },
        [AnimType.ExitBasicZoom + PresetSubtype.ToSlideBottom]: {
            scale: 2,
            scaleX: 2,
            scaleY: 2,
            translateX: 0,
            translateY: maxHeight + (objHeight / 2),
            opacity: 0,
        },
        [AnimType.ExitBasicZoom + PresetSubtype.InSlightly]: {
            scale: 4 / 3,
            scaleX: 4 / 3,
            scaleY: 4 / 3,
            opacity: 0,
        },
        [AnimType.EntrBasicSwivel + PresetSubtype.Across]: {
            rotateY: 360,
            opacity: 1,
        },
        [AnimType.ExitBasicSwivel + PresetSubtype.Across]: {
            rotateY: -90,
            opacity: 0,
        },
        [AnimType.EntrBasicSwivel + PresetSubtype.Vertical]: {
            rotateX: 360,
            opacity: 1,
        },
        [AnimType.ExitBasicSwivel + PresetSubtype.Vertical]: {
            rotateX: -90,
            opacity: 0,
        },
        [AnimType.CutIn + PresetSubtype.Top]: {
            translateY: 0,
        },
        [AnimType.CutIn + PresetSubtype.Bottom]: {
            translateY: 0,
        },
        [AnimType.CutIn + PresetSubtype.Left]: {
            translateX: 0,
        },
        [AnimType.CutIn + PresetSubtype.Right]: {
            translateX: 0,
        },
        [AnimType.CutOut + PresetSubtype.Top]: {
            translateY: -objHeight,
        },
        [AnimType.CutOut + PresetSubtype.Bottom]: {
            translateY: objHeight,
        },
        [AnimType.CutOut + PresetSubtype.Left]: {
            translateX: -objWidth,
        },
        [AnimType.CutOut + PresetSubtype.Right]: {
            translateX: objWidth,
        },
    };
    return animDic;
}

const getRotateToStyle = (timeNode, playMode: string): AnimationStyle => {
    const animType = getAnimTypeByPlayMode(timeNode, playMode);
    if (animType !== AnimType.Rotate) return {};
    const byValue = playMode === PLAY_MODE.play ? timeNode.by : timeNode.props.by;
    const rotateValue = timeNode.elementModel.props.style.rotate || 0;
    const finalRotateValue = byValue ? byValue + rotateValue : rotateValue;

    return { rotate: finalRotateValue };
};

const getPluseToStyle = (timeNode: any): AnimationStyle => {
    const { duration } = timeNode.props;
    const halfKeyframe  = { value: 1.3, duration: duration / 2, rate: 0.5 };
    const endKeyframe = { value: 1, duration: duration / 2, rate: 1 };
    const halfOpacityKeyframe = { value: 0.5, duration: duration / 2, rate: 0.5  };
    return {
        scale: [halfKeyframe,  endKeyframe],
        scaleX: [halfKeyframe, endKeyframe],
        scaleY: [halfKeyframe, endKeyframe],
        opacity: [halfOpacityKeyframe, endKeyframe],
        translateX: 0,
        translateY: 0,
    };
};

function getEdgeXY(objRotate: number | undefined) {
    if (objRotate) {
        const fourPoint = getPointsAfterRotate({
            left: objLeft,
            top: objTop,
            width: objWidth,
            height: objHeight,
        }, objRotate);
        fourPoint.sort((a, b) => a.x - b.x);
        maxX = fourPoint[3].x;
        minX = fourPoint[0].x;
        fourPoint.sort((a, b) => a.y - b.y);
        maxY = fourPoint[3].y;
        minY = fourPoint[0].y;
        objHeight = maxY - minY;
        objWidth = maxX - minX;
    } else {
        maxX = objLeft + objWidth;
        minX = objLeft;
        maxY = objTop + objHeight;
        minY = objTop;
    }
}

function setToStyle(timeNode: IAnimModel, playMode: PLAY_MODE = PLAY_MODE.play): IToStyle | AnimationStyle {
    const { slideWidth, slideHeight } = getSlideWidthAndHeight(timeNode, playMode);
    const animType = getAnimTypeByPlayMode(timeNode, playMode);
    const animDirection = getAnimDirection(timeNode, playMode);
    if (slideWidth && slideHeight) {
        maxWidth = slideWidth;
        maxHeight = slideHeight;
    }
    objWidth = timeNode.elementModel.props.style.width;
    objHeight = timeNode.elementModel.props.style.height;
    objLeft = timeNode.elementModel.props.style.left;
    objTop = timeNode.elementModel.props.style.top;
    const objRotate = getTnRotate(timeNode);
    getEdgeXY(objRotate);

    if (colorAnimTypeList.includes(animType)) {
        const toStyle = getAnimToStyleConverter().convertAnimToStyle({
            unitTimeNode: timeNode.sdkData as IEGTimeNodeChoice,
            duration: timeNode.props.duration / 1000,
            elementModel: timeNode.elementModel,
        });
        return toStyle ?? {};
    }

    const handlers = {
        [AnimType.EntrFloat]: () => getEntrFloatToStyle(timeNode, playMode),
        [AnimType.ExitFloat]: () => getExitFloatToStyle(timeNode, playMode),
        [AnimType.EntrBoomerang]: () =>  getEntrBoomerangToStyle(timeNode, playMode),
        [AnimType.ExitBoomerang]: () =>  getExitBoomerangToStyle(timeNode, playMode),
        [AnimType.EntrCenterRevolve]: () =>  getCenterResolveToStyle(timeNode, playMode),
        [AnimType.ExitCenterRevolve]: () => getCenterResolveToStyle(timeNode, playMode, presetClassTypes.EXIT),
        [AnimType.SpiralIn]: () => getSpiralToStype(timeNode, playMode),
        [AnimType.SpiralOut]: () => getSpiralToStype(timeNode, playMode, presetClassTypes.EXIT),
        [AnimType.EntrBounce]: () => getBounceToStyle(timeNode, playMode),
        [AnimType.ExitBounce]: () => getBounceToStyle(timeNode, playMode, presetClassTypes.EXIT),
    };
    if (handlers[animType]) {
        return handlers[animType]();
    }

    let tempStyle: AnimationStyle = {};
    const toStyleMap: Record<string, AnimationStyle> = {
        [AnimType.FlyIn]: {
            translateX: 0,
            translateY: 0,
        },
        [AnimType.FloatUpIn]: {
            opacity: 1,
            translateY: 0,
            translateX: 0,
        },
        [AnimType.FloatDownIn]: {
            opacity: 1,
            translateY: 0,
            translateX: 0,
        },
        [AnimType.FloatUpOut]: {
            opacity: 0,
            translateY: 100,
            translateX: 0,
        },
        [AnimType.FloatDownOut]: {
            opacity: 0,
            translateY: -100,
            translateX: 0,
        },

        [AnimType.Plus]: getPluseToStyle(timeNode),
        [AnimType.Spread]: {
            opacity: 1,
            scaleX: 1,
        },
        [AnimType.EnterRotate]: {
            opacity: 1,
            rotateY: 360,
        },
        [AnimType.ExitSpread]: {
            opacity: 0,
            scaleX: 0,
        },
        [AnimType.ExitRotate]: {
            opacity: 0,
            rotateY: 360,
        },
        [AnimType.EntrGrowTurn]: {
            rotate: objRotate,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.EntrRiseUp]: {
            translateX: 0,
            translateY: 0,
            opacity: 1,
            easing: 'easeOutBack',
        },
        [AnimType.EntrSpinner]: {
            rotate: objRotate,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
            opacity: 1,
        },
        [AnimType.ExitShrinkTurn]: {
            rotate: 90 + objRotate,
            scale: 0,
            scaleX: 0,
            scaleY: 0,
            opacity: 0,
        },
        [AnimType.ExitSinkDown]: {
            translateY: objHeight + slideHeight,
        },
        [AnimType.ExitSpinner]: {
            rotate: 360 + objRotate,
            opacity: 0,
        },
        [AnimType.ExitStretch]: {
            scaleX: 1.3,
            opacity: 0,
        },
        [AnimType.EntrPinwheel]: {
            scaleX: 1,
            scaleY: 1,
            scale: 1,
            opacity: 1,
            rotate: objRotate,
            easing: 'linear',
        },
        [AnimType.ExitPinwheel]: {
            scaleX: 0,
            scaleY: 0,
            scale: 0,
            opacity: 0,
            rotate: 720 + objRotate,
            easing: 'linear',
        },
        [AnimType.EmphTransparency]: getEmphOpacityToStyle(timeNode, playMode),
        [AnimType.Rotate]: getRotateToStyle(timeNode, playMode),
        [AnimType.EntrCredits]: {
            opacity: 1,
            translateY: -maxHeight,
        },
        [AnimType.ExitCredits]: {
            opacity: 1,
            translateY: maxHeight,
        },
        [AnimType.CurveUp]: {
            opacity: 1,
            scale: 1,
            scaleX: 1,
            scaleY: 1,
        },
        [AnimType.CurveDown]: {
            opacity: 0,
            scale: 2.5,
            scaleX: 2.5,
            scaleY: 2.5,
        },
    };
    if (toStyleMap[animType]) {
        tempStyle = toStyleMap[animType];
    }

    const animDic = getToStyle();
    if (animDic[animType + animDirection]) {
        tempStyle = animDic[animType + animDirection];
    }

    if (playMode === PLAY_MODE.play) {
        Reflect.deleteProperty(tempStyle, 'easing');
    }

    return {
        ...INIT_STYLE,
        rotate: objRotate,
        ...tempStyle,
    };
}

export default setToStyle;
